import { useEffect, useRef, useState } from "react";
import AnimatedSummaryText from "./AnimatedSummaryText";

const GenerationOverlay = ({ summaryText, audioUrl }) => {
  const audioRef = useRef(null);
  const [showSummary, setShowSummary] = useState(false);
  const [displaySummary, setDisplaySummary] = useState(false);

  // 🎧 Spela upp ljud och visa text
  useEffect(() => {
    if (!audioUrl || !audioRef.current) return;

    audioRef.current.play();

    const showTextTimer = setTimeout(() => {
      setShowSummary(true);
      setDisplaySummary(true);
    }, 10000); // visa text efter 10 sek

    audioRef.current.onended = () => {
      console.log("🔊 Ljud klart – redirect om 4 sek...");
      setShowSummary(false);
      setDisplaySummary(false);
      setTimeout(() => {
        window.location.href = "/produkter";
      }, 4000);
    };

    return () => clearTimeout(showTextTimer);
  }, [audioUrl]);

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-90 text-white flex flex-col items-center justify-center px-6 py-12 overflow-y-auto">
      {displaySummary && showSummary && summaryText && (
        <div className="mt-4">
          <AnimatedSummaryText summary={summaryText} />
        </div>
      )}

      {audioUrl && <audio ref={audioRef} src={audioUrl} autoPlay hidden />}
    </div>
  );
};

export default GenerationOverlay;
